export const POPOVER = {
  "Popover.Padding.Top": {
    ref: "Space.4"
  },
  "Popover.Padding.Right": {
    defaultValue: "0"
  },
  "Popover.Padding.Bottom": {
    ref: "Space.4"
  },
  "Popover.Padding.Left": {
    defaultValue: "0"
  },
  "Popover.Bg.Color": {
    ref: "Color.White"
  },
  "Popover.Border.Color": {
    defaultValue: "transparent"
  },
  "Popover.Border.Left.Width": {
    defaultValue: "0"
  },
  "Popover.Border.Right.Width": {
    defaultValue: "0"
  },
  "Popover.Border.Top.Width": {
    defaultValue: "0"
  },
  "Popover.Border.Bottom.Width": {
    defaultValue: "0"
  },
  "Popover.Shadow": {
    ref: "Shadow.300"
  },
  "Popover.Itemdivider.Color": {
    defaultValue: "transparent"
  },
  "Popover.Itemdivider.Weight": {
    defaultValue: "0"
  },
  "Popover.Item.Padding.Top": {
    ref: "Space.12"
  },
  "Popover.Item.Padding.Right": {
    ref: "Space.16"
  },
  "Popover.Item.Padding.Bottom": {
    ref: "Space.12"
  },
  "Popover.Item.Padding.Left": {
    ref: "Space.16"
  },
  "Popover.Item.Hover.Color": {
    ref: "Color.Gray.800"
  },
  "Popover.Item.Selected.Bg.Color": {
    defaultValue: "transparent"
  },
  "Popover.Item.Selected.Icon.Color": {
    ref: "Color.Secondary.One.500"
  }
};
